import { Check, Clock } from "lucide-react";
import type { CSSProperties, ReactNode } from "react";

import { useTranslations } from "next-intl";
import { HERO_VORGANG_THREAD_PADDING_X_PX } from "./hero-vorgang-tokens";

const KBD_STYLE: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 18,
  height: 18,
  border: "1px solid rgba(11,15,25,0.15)",
  borderRadius: 4,
  background: "rgba(58,158,107,0.04)",
  fontSize: 10,
  fontWeight: 500,
  lineHeight: 1,
  color: "rgba(11,15,25,0.40)",
  flexShrink: 0,
};

function ShortcutKey(props: { readonly children: string }): ReactNode {
  return <span style={KBD_STYLE}>{props.children}</span>;
}

function SideAction(props: {
  readonly icon: ReactNode;
  readonly label: string;
  readonly shortcut: string;
  readonly iconColor: string;
}): ReactNode {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontSize: 12,
        fontWeight: 500,
        color: "rgba(11,15,25,0.40)",
        cursor: "default",
        flexShrink: 0,
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ color: props.iconColor, display: "inline-flex" }}>
        {props.icon}
      </span>
      {props.label}
      <ShortcutKey>{props.shortcut}</ShortcutKey>
    </span>
  );
}

export function HeroVorgangActionFooter(): ReactNode {
  const t = useTranslations("marketing.heroVorgangActionFooter");
  return (
    <div
      style={{
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 2,
        pointerEvents: "none",
        padding: `8px ${HERO_VORGANG_THREAD_PADDING_X_PX}px 12px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        background: "transparent",
      }}
    >
      <div
        style={{
          pointerEvents: "auto",
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          flexShrink: 0,
        }}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            height: 40,
            padding: "0 14px",
            borderRadius: 12,
            border: "1px solid rgba(11,15,25,0.10)",
            background: "#fff",
            fontSize: 13,
            color: "rgba(11,15,25,0.40)",
            cursor: "default",
            flexShrink: 0,
            whiteSpace: "nowrap",
          }}
        >
          <ShortcutKey>{t("f")}</ShortcutKey>
          <span>{t("weiterleiten")}</span>
          <span style={{ color: "rgba(11,15,25,0.28)", padding: "0 2px" }}>
            ·
          </span>
          <ShortcutKey>{t("a")}</ShortcutKey>
          <span>{t("antworten")}</span>
        </div>

        <SideAction
          icon={<Clock width={14} height={14} strokeWidth={1.9} />}
          label={t("wiedervorlage")}
          shortcut="W"
          iconColor="#E0A500"
        />

        <SideAction
          icon={<Check width={14} height={14} strokeWidth={2} />}
          label={t("erledigt")}
          shortcut="E"
          iconColor="#3A9E6B"
        />
      </div>
    </div>
  );
}
